import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS, EXPERIMENT_ORDER } from './experiments';
import { HELP_LINES } from './help-content';
import { i18n } from './i18n';
import type { GeometryContext, ExperimentKey } from './types';

bootstrapDemoShell({
  slug: '2d-geometry',
  i18n,
  experiments: EXPERIMENTS,
  order: EXPERIMENT_ORDER,
  eyebrowKey: 'app.eyebrow',
  helpLineKeys: (exp) => (exp ? HELP_LINES[exp] : undefined),
  shotToExperiment: (id) =>
    (EXPERIMENT_ORDER as readonly string[]).includes(id) ? (id as ExperimentKey) : null,
  extendContext: (base, { shotId }): GeometryContext => ({
    ...base,
    prng: makePrng(shotId !== null ? 0x2d6e0 : Date.now()),
  }),
});
